import { emit, on } from '@/events'

export const DOCUMENT_PREVIEW_EVENTS = {
  OPEN_REQUESTED: 'document_preview:open_requested',
}

/** @param {import('./documentPreviewTypes.js').ArtifactSelection} selection */
export function emitDocumentPreviewOpenRequested(selection) {
  emit(DOCUMENT_PREVIEW_EVENTS.OPEN_REQUESTED, selection)
}

/** @param {(selection: import('./documentPreviewTypes.js').ArtifactSelection) => void} handler */
export function onDocumentPreviewOpenRequested(handler) {
  return on(DOCUMENT_PREVIEW_EVENTS.OPEN_REQUESTED, handler)
}
